import { Box, Divider, HStack, Icon, Label } from '@medely/ui-kit';
import { DisplayHelpers } from '@mp/utils';
import React from 'react';
import useDialog from '@mp/hooks/useDialog';
import { WorkGapModal } from '../workGapModal/WorkGapModal.web';
import { WorkHistoryModal } from '../workHistoryModal/WorkHistoryModal.web';
import { useResumeBuilderMutations } from '../mutations';
import { IResumeItem } from '@medely/types';
import { WorkHistoryItemData } from './interface';
import { WorkGapInfo } from './WorkGapInfo';
import { WorkHistoryInfo } from './WorkHistoryInfo';
import { ExperienceEditModal } from './ExperienceEditModal.web';

export const WorkHistoryItem = ({ workHistoryItem }: { workHistoryItem: WorkHistoryItemData }) => {
  const { deleteWorkGap, deleteWorkHistory } = useResumeBuilderMutations();
  const workGapModalBehavior = useDialog();
  const ExperienceEditModalBehavior = useDialog();
  const workHistoryModalBehavior = useDialog();

  const dates = `${
    workHistoryItem.start_date ? DisplayHelpers.getDate(workHistoryItem?.start_date) : ''
  } - ${
    workHistoryItem.currently_work_here
      ? 'Present'
      : workHistoryItem.end_date
      ? DisplayHelpers.getDate(workHistoryItem.end_date || '')
      : ''
  }`;

  const handleEditClick = () => {
    workHistoryItem.isWorkGap
      ? workGapModalBehavior.openDialog()
      : workHistoryModalBehavior.openDialog();
  };

  const handleDeleteClick = () => {
    workHistoryItem.isWorkGap
      ? deleteWorkGap(workHistoryItem.id)
      : deleteWorkHistory(workHistoryItem.id);
  };

  return (
    <>
      <HStack
        alignItems="center"
        justifyContent="space-between"
        py={2}
        pl={2}
        onClick={ExperienceEditModalBehavior.openDialog}
      >
        <Box>
          <Label size="m" testId="work-history-item-date">
            {dates}
          </Label>

          {workHistoryItem.isWorkGap ? (
            <WorkGapInfo workHistoryItem={workHistoryItem} />
          ) : (
            <WorkHistoryInfo workHistoryItem={workHistoryItem} />
          )}
        </Box>
        <Icon name="chevron-right" variant="custom" color="text.secondary" iconSize="16px" />
      </HStack>
      <ExperienceEditModal
        deleteExperience={handleDeleteClick}
        openEditModal={handleEditClick}
        onClose={ExperienceEditModalBehavior.closeDialog}
        open={ExperienceEditModalBehavior.open}
      />
      <WorkGapModal
        open={workGapModalBehavior.open}
        onClose={workGapModalBehavior.closeDialog}
        workGap={workHistoryItem as IResumeItem}
      />
      <WorkHistoryModal
        open={workHistoryModalBehavior.open}
        onClose={workHistoryModalBehavior.closeDialog}
        workHistory={workHistoryItem as IResumeItem}
        experienceType={workHistoryItem.clinical ? 'clinical' : 'nonClinical'}
      />
      <Divider />
    </>
  );
};
